import isDate from 'lodash/isDate.js';
import { addDays } from '../date-info.js';
import { datesAreEqual, pageForDate } from '../helpers.js';

class SinglePicker {
  constructor(_ref) {
    let {
      format,
      parse
    } = _ref;
    Object.assign(this, {
      format,
      parse
    });
  }
  hasValue(value) {
    if (isDate(value)) {
      return true;
    }
    if (new Date(value).getTime() > 0) {
      return true;
    }
    return false;
  }
  normalize(value) {
    return value && new Date(value);
  }
  valuesAreEqual(a, b) {
    return datesAreEqual(a, b);
  }
  formatValue(value) {
    return this.hasValue(value) ? this.format(value) : '';
  }
  parseValue(text) {
    const value = this.parse(text);
    return isDate(value) ? value : null;
  }
  filterDisabled(_ref2) {
    let {
      value,
      isRequired,
      disabled,
      fallbackValue
    } = _ref2;
    if (!this.hasValue(value) && isRequired) {
      return fallbackValue;
    }
    if (this.hasValue(value) && disabled && disabled.intersectsDate(value)) {
      return null;
    }
    return value;
  }
  getPageRange(value) {
    if (!this.hasValue(value)) {
      return null;
    }
    const from = pageForDate(value);
    return {
      from,
      to: from
    };
  }
  parseShortcutValue(value) {
    value = isDate(value) ? value : addDays(new Date(), value);
    value.setHours(0, 0, 0, 0);
    return this.normalize(value);
  }
  handleShortcutSelect(shortcut, picker) {
    if (picker.dateIsValid(shortcut.value)) {
      picker.model = shortcut.value;
    }
  }
  handleDayClick(day, picker) {
    if (!picker.dateIsValid(day.date)) {
      return;
    }
    if (this.valuesAreEqual(day.date, picker.model)) {
      if (!picker.isRequired) {
        picker.model = null;
        picker.$emit('select-date', {
          value: null
        });
      } else {
        picker.togglePopover();
      }
    } else {
      picker.model = day.date;
      picker.$emit('select-date', {
        value: day.date
      });
    }
  }
  handleDayMouseEnter() {}
}

export { SinglePicker as default };
//# sourceMappingURL=single.js.map
